function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import React, { useEffect } from 'react';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { T } from 'shared/helper/translate';
import { searchAbstracts, viewAbstract } from 'researcher/abstract/actions';
import Link from 'shared/components/Link';
import { trackAbstractOutputViewed } from 'researcher/helpers/abstractMixpanelEvents';
import useAbstractTrackingProps from 'researcher/helpers/useAbstractTrackingProps';
import RubriqLoadingSpinner from '../../components/RubriqLoadingSpinner';
import './abstract-output.scss';
import RubriqAbstractOutputHeader from './RubriqAbstractOutputHeader';
import RubriqAbstractSection from './RubriqAbstractSection';
import { parseStructuredAbstract, buildKeywordsPlainText, hasSimpleSummary, hasGraphicalAbstract, sanitizeFilename } from './abstractOutputHelpers';

// Temporarily hidden - flip back to true to re-enable.
var SHOW_GRAPHICAL_ABSTRACT = false;
var renderAbstractBody = function renderAbstractBody(data) {
  if (data.abstractType === 'structured') {
    var segments = parseStructuredAbstract(data.generatedAbstract);
    var hasHeadings = segments.some(function (segment) {
      return segment.heading;
    });
    if (hasHeadings) {
      return /*#__PURE__*/React.createElement("div", {
        className: "d-flex flex-column gap-2"
      }, segments.map(function (segment, index) {
        return (
          /*#__PURE__*/
          // eslint-disable-next-line react/no-array-index-key
          React.createElement("p", {
            key: index,
            className: "mb-0 pb-4 border-bottom"
          }, segment.heading && /*#__PURE__*/React.createElement("strong", null, segment.heading, ": "), segment.body)
        );
      }));
    }
  }
  return /*#__PURE__*/React.createElement("p", {
    className: "mb-0",
    style: {
      whiteSpace: 'pre-line'
    }
  }, data.generatedAbstract);
};
var RubriqAbstractOutput = function RubriqAbstractOutput() {
  var _listItem$file;
  var _useParams = useParams(),
    documentIdentity = _useParams.documentIdentity;
  var dispatch = useDispatch();
  var _useSelector = useSelector(function (state) {
      return state;
    }),
    abstract = _useSelector.abstract;
  var trackingProps = useAbstractTrackingProps();
  var viewed = abstract.viewedAbstracts[documentIdentity];
  var listItem = abstract.abstracts.find(function (a) {
    return a.identity === documentIdentity;
  });
  useEffect(function () {
    dispatch(viewAbstract(documentIdentity));
  }, [documentIdentity]);

  // Fire Abstract Output Viewed once the data is ready
  useEffect(function () {
    var _data$generatedWordCo;
    if (!viewed || viewed.loading || !viewed.data) return;
    var data = viewed.data;
    var optionalOutputsShown = [];
    if (hasSimpleSummary(data)) optionalOutputsShown.push('simple_language_summary');
    if (SHOW_GRAPHICAL_ABSTRACT && hasGraphicalAbstract(data)) optionalOutputsShown.push('graphical_abstract');
    trackAbstractOutputViewed(_objectSpread({
      abstractType: data.abstractType,
      wordCount: (_data$generatedWordCo = data.generatedWordCount) !== null && _data$generatedWordCo !== void 0 ? _data$generatedWordCo : null,
      optionalOutputsShown: optionalOutputsShown
    }, trackingProps));
  }, [viewed === null || viewed === void 0 ? void 0 : viewed.loading, viewed === null || viewed === void 0 ? void 0 : viewed.data]);
  useEffect(function () {
    // Covers a direct/refreshed navigation to this URL, where the list (and its file
    // name) was never loaded because RubriqAbstract never mounted.
    if (!listItem && !abstract.status.searchCompleted) {
      dispatch(searchAbstracts());
    }
  }, [documentIdentity]);
  if (!viewed || viewed.loading) {
    return /*#__PURE__*/React.createElement(RubriqLoadingSpinner, {
      text: "loading abstract"
    });
  }
  if (viewed.error || !viewed.data) {
    return /*#__PURE__*/React.createElement("div", {
      className: "p-4 text-center text-danger"
    }, /*#__PURE__*/React.createElement(T, {
      source: "We were unable to load this abstract. Please try again."
    }));
  }
  var data = viewed.data;
  var fileName = (listItem === null || listItem === void 0 || (_listItem$file = listItem.file) === null || _listItem$file === void 0 ? void 0 : _listItem$file.name) || '';
  var filenameBase = sanitizeFilename(fileName || documentIdentity);
  var keywords = data.generatedKeywords || [];
  return /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-3"
  }, /*#__PURE__*/React.createElement(Link, {
    to: "/rubriq/abstract",
    className: "d-inline-flex align-items-center gap-1 fw-semibold"
  }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    icon: "fa-regular fa-arrow-left"
  }), /*#__PURE__*/React.createElement(T, {
    source: "Back to List"
  })), /*#__PURE__*/React.createElement("div", {
    className: "rubriq-abstract-output-card border rounded-4"
  }, /*#__PURE__*/React.createElement(RubriqAbstractOutputHeader, {
    fileName: fileName,
    data: data
  }), /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-column gap-2 p-3"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "fs-5 fw-semibold m-0"
  }, /*#__PURE__*/React.createElement(T, {
    source: "Abstract"
  })), renderAbstractBody(data)), /*#__PURE__*/React.createElement(RubriqAbstractSection, {
    heading: "Keywords",
    copyTooltip: "Copy keywords",
    downloadTooltip: "Download keywords",
    filename: "".concat(filenameBase, "-keywords"),
    failureMessage: /*#__PURE__*/React.createElement(T, {
      source: "We were unable to generate Keywords. Please try again."
    }),
    getPlainText: function getPlainText() {
      return buildKeywordsPlainText(data);
    },
    hasContent: keywords.length > 0,
    section: "keywords"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex flex-wrap gap-2 border-bottom pb-4"
  }, keywords.map(function (keyword) {
    return /*#__PURE__*/React.createElement("span", {
      key: keyword,
      className: "badge rounded-pill text-bg-light border px-3 py-2 fw-normal"
    }, keyword);
  }))), hasSimpleSummary(data) && /*#__PURE__*/React.createElement(RubriqAbstractSection, {
    heading: "Simple Language Summary",
    icon: "fa-solid fa-check",
    accent: "blue",
    copyTooltip: "Copy simple language summary",
    downloadTooltip: "Download simple language summary",
    filename: "".concat(filenameBase, "-simple-language-summary"),
    failureMessage: /*#__PURE__*/React.createElement(T, {
      source: "We were unable to generate a Simple Language Summary. Please try again."
    }),
    getPlainText: function getPlainText() {
      return data.generatedSimpleSummary;
    },
    hasContent: !!data.generatedSimpleSummary,
    section: "simple_language_summary"
  }, /*#__PURE__*/React.createElement("p", {
    className: "mb-0"
  }, data.generatedSimpleSummary)), SHOW_GRAPHICAL_ABSTRACT && hasGraphicalAbstract(data) && /*#__PURE__*/React.createElement(RubriqAbstractSection, {
    heading: "Graphical Abstract",
    icon: "fa-solid fa-shapes",
    accent: "purple",
    copyTooltip: "Copy graphical abstract",
    downloadTooltip: "Download graphical abstract",
    filename: "".concat(filenameBase, "-graphical-abstract"),
    failureMessage: /*#__PURE__*/React.createElement(T, {
      source: "We were unable to generate a Graphical Abstract. Please try again."
    }),
    getPlainText: function getPlainText() {
      return data.generatedGraphicalAbstractPrompt;
    },
    hasContent: !!data.generatedGraphicalAbstractPrompt,
    section: "graphical_abstract"
  }, /*#__PURE__*/React.createElement("p", {
    className: "mb-0"
  }, data.generatedGraphicalAbstractPrompt))));
};
export default RubriqAbstractOutput;